import React from 'react';
import { Container, RegularText, SizedBox } from 'src/components';

export const AboutTripContent = ({ data }: { data: string }) => {
  return (
    <Container>
      <RegularText fontWeight="bold" textLang="aboutNham24Trip" />
      <SizedBox height="small" />
      <RegularText textAlign="left">{data}</RegularText>
    </Container>
  );
};
